import {
    PHOTO_UPLOAD,
    PHOTO_UPLOAD_CONFIRM,
    PHOTO_UPLOAD_MAX_QUEUE,
    PHOTO_UPLOAD_MAX_TIME,
    PHOTO_UPLOAD_BAD_ACCOUNT
} from "data/links";

export const LOADING_MODE = "loading";
export const MAX_QUEUE_MODE = "max-queue";
export const MAX_TIME_MODE = "max-time";
export const INCOMPLETE_ACCOUNT_MODE = "incomplete-account";
export const CONFIRM_MODE = "confirm";
export const UPLOAD_MODE = "upload";

export function getPath(mode) {
    switch (mode) {
        case LOADING_MODE:
            return null; // don't redirect while loading
        case MAX_QUEUE_MODE:
            return PHOTO_UPLOAD_MAX_QUEUE;
        case MAX_TIME_MODE:
            return PHOTO_UPLOAD_MAX_TIME;
        case INCOMPLETE_ACCOUNT_MODE:
            return PHOTO_UPLOAD_BAD_ACCOUNT;
        case CONFIRM_MODE:
            return PHOTO_UPLOAD_CONFIRM;
        default:
            return PHOTO_UPLOAD;
    }
}
